import { render, staticRenderFns } from "./EditarSancion.vue?vue&type=template&id=3a525ae9"
import script from "./EditarSancion.vue?vue&type=script&lang=js"
export * from "./EditarSancion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports